import React from "react";
import { Perimetre, Role } from "api/auth";
import { Navigate } from "react-router-dom";
import { useUser } from "utils/useGetUser";
import { useGetHabilitation } from "utils/useGetHabilitation";
import FullScreenLoading from "components/FullScreenLoading";

export interface ProtectedRouteProps {
  niveauRattachements?: Role[];
  perimetres?: Perimetre[];
  redirectTo?: string;
  children?: React.ReactNode;
}

export function ProtectedRoute({
  niveauRattachements = [],
  perimetres = [],
  redirectTo = "/",
  children,
}: ProtectedRouteProps) {
  const user = useUser();
  const { perimetresAllowed, loading } = useGetHabilitation(user?.codeSociete, perimetres);

  // Seul cas où une requete est nécessaire pour avoir les habilitations et les périmètres
  // Donc il faut attendre le résultat de la requête avant de décider s'il faut rediriger ou non
  if (user?.role === Role.INTERMEDIAIRE && perimetres.length > 0 && loading)
    return <FullScreenLoading />;

  const isNiveauRattachementAllowed =
    niveauRattachements.length === 0 || niveauRattachements.includes(user?.role);
  const isPerimetreAllowed = user?.role !== Role.INTERMEDIAIRE || perimetresAllowed;
  const isAllowed = isNiveauRattachementAllowed && isPerimetreAllowed;

  if (isAllowed) return <>{children}</>;

  return <Navigate to={redirectTo} replace />;
}
